import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import { connectRoutes } from 'redux-first-router';
import restoreScroll from 'redux-first-router-restore-scroll';
import createHistory from 'history/createBrowserHistory';

import { pages, routeToPathMap } from './pages';
import pageReducer from './pageReducer';
import viewReducer from './viewReducer';
import titleReducer from './titleReducer';

const history = createHistory();

const {
  reducer: routerReducer,
  middleware: routerMiddleware,
  enhancer: routerEnhancer,
} = connectRoutes(history, routeToPathMap, { restoreScroll: restoreScroll() });

const rootReducer = combineReducers({
  location: routerReducer,
  view: viewReducer,
  page: pageReducer,
  title: titleReducer,
  pages: () => pages,
});

const middlewares = applyMiddleware(routerMiddleware);

export const store = createStore(
  rootReducer,
  compose(routerEnhancer, middlewares)
);



// WEBPACK FOOTER //
// ./application/store/store.js